// extracted by mini-css-extract-plugin
export default {"text":"claimCreate_text__Mp4bf","grow":"claimCreate_grow__pUz02"};